// Secure
export const environment = {
  production: true,
  host: "https://api.shop.embla.no",
  emblanoUrl : "https://embla.no" 
};



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/environments/environment.ts